import { useCallback, useState } from "react";
import { useCreatePartnerCodeGroupMutation } from "../../Hooks/useCreatePartnerGroupMutation";
import PartnerCodeGroupFormModal from "../PartnerCodeGroupForm/PartnerCodeGroupForm";

function CopyPartnerCodeGroupModel({
  isOpen,
  closeCreatePartnerCodeGroupModal,
  setToast,
  partnerCodeGroup,
  refetch,
}) {
  const initialPartnerCodeGroupData = {
    ...partnerCodeGroup,
    name: `${partnerCodeGroup?.name} copy`,
  };

  const [partnerCodeGroupData, setPartnerCodeGroupData] = useState(
    initialPartnerCodeGroupData
  );
  const [copyPartnerCodeGroupMutation, { loading }] =
    useCreatePartnerCodeGroupMutation();

  const handleComplete = useCallback(() => {
    setToast({
      open: true,
      type: "success",
      title: `Code Group ${partnerCodeGroupData.name} Created!`,
      description: "You have just published a partner Group!",
    });
    setPartnerCodeGroupData(initialPartnerCodeGroupData);
    closeCreatePartnerCodeGroupModal();
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    closeCreatePartnerCodeGroupModal,
    partnerCodeGroupData.name,
    refetch,
    setToast,
  ]);

  const handleCopyPartnerCodeGroup = useCallback(
    async (data) => {
      const dataToUse = data || partnerCodeGroupData;
      /* eslint-disable no-unused-vars */
      const {
        programId,
        id,
        codeCount,
        exhaustedCode,
        importedDate,
        isImported,
        status,
        processingStatus,
        isAttached,
        uniqueCodeCount,
        allocationCount,
        maxAllocation,
        rewardItemFileData,
        ...dataWithoutFiles
      } = dataToUse;

      const dataToSubmit = {
        ...dataWithoutFiles,
        rewardItemFileData: [],
      };

      return new Promise((resolve) => {
        const onSuccess = (entity) => {
          resolve(entity);
        };

        const onFailure = (error) => {
          setToast({
            open: true,
            type: "error",
            title: `Error on creating Code Group: ${dataToUse.name}`,
            description: error?.message || "",
          });
          resolve(null);
        };

        copyPartnerCodeGroupMutation(onSuccess, onFailure, dataToSubmit);
      });
    },
    [copyPartnerCodeGroupMutation, partnerCodeGroupData, setToast]
  );

  return (
    <PartnerCodeGroupFormModal
      isOpen={isOpen}
      toggleCreatePartnerCodeModal={closeCreatePartnerCodeGroupModal}
      closeModal={closeCreatePartnerCodeGroupModal}
      partnerCodeGroupData={partnerCodeGroupData}
      setPartnerCodeGroupData={setPartnerCodeGroupData}
      handleMutation={handleCopyPartnerCodeGroup}
      handleComplete={handleComplete}
      loading={loading}
      title="Copy"
      isEditMode={false}
    />
  );
}

export default CopyPartnerCodeGroupModel;
